// src/componentsdash/Modulos/Historia Clinica/ModalesEdicion/ModalConfirmacion.js
import React, { useEffect, useRef } from "react";
import "./ModalEdicion.css";

const TEXTOS = {
  historia: {
    titulo: "Confirmar guardado de historia clínica",
    cuerpo:
      "La información registrada en antecedentes puede actualizarse posteriormente. El resto de los apartados forman parte del expediente clínico y, conforme a la normatividad vigente, no pueden modificarse una vez registrados; únicamente es posible añadir indicaciones adicionales.",
    boton: "Guardar",
  },
  consulta: {
    titulo: "Confirmar guardado de consulta",
    cuerpo:
      "La información registrada forma parte del expediente clínico y, conforme a la normatividad vigente, no puede modificarse posteriormente; únicamente es posible añadir indicaciones adicionales.",
    boton: "Guardar",
  },
};
 

function ModalConfirmacion({ isOpen, onClose, onConfirm, tipo = "consulta" }) {
  const refContenido = useRef(null);
  const { titulo, cuerpo, boton } = TEXTOS[tipo] ?? TEXTOS.consulta;

  // Cerrar con ESC y enfocar el modal al abrir
  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", onKey);
    refContenido.current?.focus();
    return () => document.removeEventListener("keydown", onKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-confirmacion-titulo"
      onClick={onClose} // click en overlay cierra
    >
      <div
        className="modal-content"
        tabIndex={-1}
        ref={refContenido}
        onClick={(e) => e.stopPropagation()} // no cerrar al hacer click dentro
      >
        <h3 >{titulo}</h3>

        <p className="info-alert">{cuerpo}</p>

        <div className="modal-buttons">
          
          <button
            type="button"
            className="btn-guardar"
            onClick={onConfirm}
            autoFocus
          >
            {boton}
          </button>
          <button type="button" className="btn-cancelar" onClick={onClose}>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}

export default ModalConfirmacion;
